// Module
var code = "<svg width=\"10\" height=\"12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.837 7.606a2 2 0 0 0 0-3.212L3.692.575C2.372-.405.5.538.5 2.181V9.82c0 1.643 1.872 2.585 3.192 1.606l5.145-3.82z\" fill=\"#3B3B3B\"/></svg>";
// Exports
module.exports = code;